import { render, staticRenderFns } from "./AdminBrands.vue?vue&type=template&id=c3c39cfc"
import script from "./AdminBrands.vue?vue&type=script&lang=js"
export * from "./AdminBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3c39cfc')) {
      api.createRecord('c3c39cfc', component.options)
    } else {
      api.reload('c3c39cfc', component.options)
    }
    module.hot.accept("./AdminBrands.vue?vue&type=template&id=c3c39cfc", function () {
      api.rerender('c3c39cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminBrands.vue"
export default component.exports